import LineIcon from '@/components/base/LineIcon';

export default function MobileCTA() {
  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-background-50/95 backdrop-blur border-t border-background-200 px-3 py-2 flex gap-2">
      <a
        href="tel:+81120219620"
        className="flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-bold text-sm whitespace-nowrap cursor-pointer transition-colors"
      >
        <span className="w-5 h-5 flex items-center justify-center">
          <i className="ri-phone-fill" />
        </span>
        電話で今すぐ相談
      </a>
      <a
        href="https://lin.ee/yKaHc4I"
        target="_blank"
        rel="noopener noreferrer"
        className="flex-1 flex items-center justify-center gap-2.5 px-4 py-3 rounded-md bg-accent-700 hover:bg-accent-800 text-background-50 font-bold text-sm whitespace-nowrap cursor-pointer transition-colors"
      >
        <LineIcon className="w-5 h-5 shrink-0" />
        LINEで無料見積り
      </a>
    </div>
  );
}